// services/categorieService.ts
import axios from "axios";
import { CMS_KAFINTECH_API_URL } from "../../config/api";
import { PaginatedResponse } from "../../types/core/PaginatedResponse";
import { Categorie } from "../../types/features/vitrine/Post";


export const categorieService = {
  // 🔓 PUBLIC - Pas de token nécessaire
  async getAll(page: number = 1, perPage: number = 20): Promise<PaginatedResponse<Categorie>> {
    try {
      const response = await axios.get(`${CMS_KAFINTECH_API_URL}/blog/categories`, {
        params: { page, per_page: perPage },
      });
      return response.data;
    } catch (error) {
      console.error("Erreur lors du chargement des catégories", error);
      throw error;
    }
  },

  // 🔓 PUBLIC - Pas de token nécessaire
  async getById(id: string): Promise<Categorie> {
    try {
      const response = await axios.get(`${CMS_KAFINTECH_API_URL}/blog/categories/${id}`);
      return response.data;
    } catch (error) {
      console.error("Erreur lors du chargement de la catégorie", error);
      throw error;
    }
  },

  // ✅ NOUVEAU - Récupérer les catégories par produit
  async getByProductName(
    productName: string,
    page: number = 1,
    perPage: number = 20
  ): Promise<PaginatedResponse<Categorie>> {
    try {
      const response = await axios.get(`${CMS_KAFINTECH_API_URL}/blog/categories/product/${productName}`, {
        params: { page, per_page: perPage },
      });
      return response.data;
    } catch (error) {
      console.error("Erreur lors du chargement des catégories par produit", error);
      throw error;
    }
  },

  // ✅ NOUVEAU - Récupérer les catégories par produit avec leurs posts
  async getByProductNameWithPosts(
    productName: string,
    page: number = 1,
    perPage: number = 20
  ): Promise<PaginatedResponse<Categorie>> {
    try {
      const response = await axios.get(`${CMS_KAFINTECH_API_URL}/blog/categories/product/${productName}/with-posts`, {
        params: { page, per_page: perPage },
      });
      return response.data;
    } catch (error) {
      console.error("Erreur lors du chargement des catégories avec posts", error);
      throw error;
    }
  },


};